import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./VersionInfoDialog.css";
import km_logo from "../../img/km_logo_vinfo.svg";
export default function VersionInfoDialog(props) {
    const getWebOssList = () => {
         window.open('/oss-report.html', '_blank');
    };
    return (
        <Modal id="dandoriVersionInfo" className="jobManagerPage" show={props.show} onHide={props.handleClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {
                        <div className="content-title">
                            <span>{props.intl.formatMessage({ id: "ds_version_title" })}</span>
                        </div>
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <img src={km_logo} alt="km_logo" />
                <div className="label ver">
                    <span>
                        {props.intl.formatMessage({ id: "ds_dashboard_version" })}
                        {props.intl.formatMessage({ id: "ds_version_ds_num" })}
                    </span>
                </div>
                <div className="label copyright">
                    <span>
                        {props.intl.formatMessage({ id: "ds_version_copyright" })}
                        <span>&nbsp;</span>
                        {props.intl.formatMessage({ id: "ds_version_companyName" })}
                    </span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="ossInfo">
                    <a
                        className="modal-weboss"
                        onClick={() => getWebOssList()}
                    >
                        {props.intl.formatMessage({ id: "ds_version_oss" })}
                    </a>
                </div>
                <Button variant="secondary" className="cancelBtn" onClick={props.handleClose}>
                    {props.intl.formatMessage({ id: "ds_import_cancle_btn" })}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
